import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";

const TopMenu = ({title})=>{
    return <>
        <Navbar bg="light" expand="lg" className="mb-4">
            <Container>
                <Navbar.Brand href="#home">{title?title:'OAuth2 Authentication'}</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/">กลับไปยังหน้าระบบ</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    </>
}
export default TopMenu;
